module.exports = __webpack_public_path__ + "img/fond_contact_2.f32a12ac.jpg";